.leftAligned {
    display: block;
    margin-top: 20px;
    max-width: 900px;
    padding-left: 5%;
    padding-right: 5%;
    position: relative;
    width: 100%;

    & > * {
        margin: 0;
    }
}
